import type { CustomerWorkItem } from 'api/models/mainservice';
import type { WorkItem } from 'common/models';
import type { CustomerKind } from 'pages/customers/models';

export const getCompanyKindTranslateKey = (kind: string) =>
  `customerKind.${kind.toLocaleLowerCase()}`;

export const getCustomerKindTranslateKey = (kind: CustomerKind) => kind.toLowerCase();

export const getCustomerWorkItems = (
  workItems: WorkItem[],
  customerWorkItems: CustomerWorkItem[]
) =>
  workItems.reduce((acc: WorkItem[], workItem) => {
    const customerWorkItem = customerWorkItems.find((x) => x.workItemId === workItem.id);

    if (customerWorkItem?.isHidden) {
      return acc;
    }

    return [...acc, { ...workItem, price: customerWorkItem?.price || workItem.price }];
  }, []);
